import { useEffect, useRef, useState } from 'react';
import { countPromptTokens } from '../services/api/prompts';
import { heuristicTokenCount } from '../components/prompt/promptUtils';

export default function useTokenCount(keycloak, text, modelIds, debounceMs = 400) {
  const [estimates, setEstimates] = useState([]);
  const [loading, setLoading] = useState(false);
  const abortRef = useRef(null);
  const heuristic = heuristicTokenCount(text);

  useEffect(() => {
    if (!keycloak?.token || !text) {
      setEstimates([]);
      return undefined;
    }

    const timer = setTimeout(async () => {
      if (abortRef.current) abortRef.current.abort();
      const controller = new AbortController();
      abortRef.current = controller;
      setLoading(true);
      try {
        const result = await countPromptTokens(keycloak, text, modelIds);
        if (!controller.signal.aborted) {
          setEstimates(result.estimates || []);
        }
      } catch {
        if (!controller.signal.aborted) {
          setEstimates([]);
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    }, debounceMs);

    return () => {
      clearTimeout(timer);
      if (abortRef.current) abortRef.current.abort();
    };
  }, [keycloak, text, modelIds?.join(','), debounceMs]);

  return { estimates, loading, heuristic };
}
